//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockStockBatchAssigned', {
//        templateUrl: 'views/components/views/stockStockBatchAssigned/stockStockBatchAssigned.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stockStockBatchAssignedService', function ($stateParams, stockStockBatchAssignedService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeyno = $stateParams.stock_keyno;

//            vm.model = {
//                itemsListAssigned: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadAssigned() {
//                vm.model.itemsListAssigned = await stockStockBatchAssignedService.listAssigned({ stock_keyno: stockKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadAssigned();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
